module["exports"] = [
  "GmbH",
  "AG",
  "Gruppe",
  "KG",
  "GmbH & Co. KG",
  "UG",
  "OHG"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/company/legal_form.js
// module id = 1991
// module chunks = 2